import { ApplicationConfig, importProvidersFrom, isDevMode } from '@angular/core';
import {
  provideRouter,
  withEnabledBlockingInitialNavigation,
  withInMemoryScrolling,
  withRouterConfig,
} from '@angular/router';
import { ipensiiAppRoutes } from './ipensii-app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import localeRo from '@angular/common/locales/ro';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { environment } from '../environments/environment';
import { EnvironmentModule } from '@irian-ro/util-environment';
import { provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { provideFeatureSharedState } from '@ipensii/shared/feature-shared-state';
import { httpClientInterceptors, httpRequestInterceptor, provideAuth } from '@ipensii/shared/data-access-shared';
import { provideDataAccessError } from '@ipensii/error/data-access-error';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TranslateModule } from '@ngx-translate/core';
import { NgxWebstorageModule } from 'ngx-webstorage';
import { ExceptionModule } from '@irian-ro/exception-service-module';

const defaultLang = 'ro';

export const ipensiiAppConfig: ApplicationConfig = {
  providers: [
    MessageService,
    ConfirmationService,
    importProvidersFrom(
      BrowserAnimationsModule,
      TranslateModule.forRoot({ defaultLanguage: defaultLang }),
      NgxWebstorageModule.forRoot({ prefix: 'ip', separator: '-' }),
      EnvironmentModule.forRoot(environment),
      ExceptionModule.forRoot({})
    ),
    provideRouter(
      ipensiiAppRoutes,
      withEnabledBlockingInitialNavigation(),
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' }),
      withRouterConfig({ onSameUrlNavigation: 'reload' })
    ),
    provideHttpClient(withInterceptors([...httpClientInterceptors, httpRequestInterceptor])),
    provideStore(),
    provideStoreDevtools({
      maxAge: 25, // Retains last 25 states
      logOnly: !isDevMode(), // Restrict extension to log-only mode
      autoPause: true, // Pauses recording actions and state changes when the extension window is not open
      trace: false, //  If set to true, will include stack trace for every dispatched action, so you can see it in trace tab jumping directly to that part of code
      traceLimit: 75, // maximum stack trace frames to be stored (in case trace option was provided as true)
      connectInZone: true,
    }),
    provideFeatureSharedState(),
    provideAuth({ authConfig: environment.config }),
    provideDataAccessError(),
  ],
};

registerLocaleData(localeRo, defaultLang);
